import React from "react";
import "./Standard_Visiting_Info_Cards.css";
import { Table } from "react-bootstrap";

function Standard_Visiting_Info_Cards({ data }) {
  const productSpecifications = [
    { label: "Card Type", value: "Translucent Card - Rounded corner" },
    { label: "Orientation", value: "Landscape" },
    { label: "Materials", value: "Translucent Card (185 micron Thick Card)" },
    { label: "Shape and Size", value: "Rectangle (3.5 x 2 in)" },
    { label: "Orientation", value: "Portrait" },
  ];

  return (
    <>
      <section className="Product_Specification_card Standard_Visiting_Info_Cards">
        <div className="My_order_card">
          <div className="row">
            {/* Standard Visiting Cards Section */}
            <div className="col-md-12 col-sm-12 ">
              <div className="card_inner_content card_inner_content_two">
                <div className="main_table_holder">
                  <div className="heading_holder">
                    <h4>{data?.product?.name}</h4>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="heading_table_holder">
                        <div className="info_table_holder">
                          <Table responsive>
                            <tbody>
                              {/* {productSpecifications.map((spec, index) => ( */}
                              {data?.combination?.round_corner && (
                                <tr>
                                  <td>Card Type</td>
                                  <td> Rounded corner</td>
                                </tr>
                              )}
                              {data?.combination?.Orientation && (
                                <tr>
                                  <td>Orientation</td>
                                  <td>{data.combination.Orientation.name}</td>
                                </tr>
                              )}
                              {data?.combination?.Material && (
                                <tr>
                                  <td>Material</td>
                                  <td>{data.combination.Material.name}</td>
                                </tr>
                              )}
                              {data?.combination?.Size && (
                                <tr>
                                  <td>Size</td>
                                  <td>{data.combination.Size.name}</td>
                                </tr>
                              )}
                              {data?.combination?.Lamination && (
                                <tr>
                                  <td>Lamination</td>
                                  <td>{data.combination.Lamination.name}</td>
                                </tr>
                              )}
                              {data?.combination?.Envelope && (
                                <tr>
                                  <td>Envelope</td>
                                  <td>{data.combination.Envelope.name}</td>
                                </tr>
                              )}
                              {data?.combination?.PrintingLocation && (
                                <tr>
                                  <td>Print</td>
                                  <td>{data.combination.PrintingLocation.name}</td>
                                </tr>
                              )}
                              {data?.product?.Shape && (
                                <tr>
                                  <td>Shape</td>
                                  <td>{data?.product?.Shape.name}</td>
                                </tr>
                              )}

                              {/* ))} */}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Standard_Visiting_Info_Cards;
